var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"header-wrap"},[_c('w-top-nav'),_c('w-header-container'),_c('w-header-category')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }